// extracted by mini-css-extract-plugin
export default {"chartContainer":"StatChart_chartContainer__82bXF"};